<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="'Banners Page'"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="'Banners Page Edit'"
      :title="'Banners Page Edit'"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'Name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>

          <p class="form-create__label">Page</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'page'"
              :label="'page'"
              :type="'text'"
              :placeholder="'Page'"
              :error-messages="validationErrors['page']"
              isBordered
            />
          </div>

          <p class="form-create__label">Link</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'link'"
              :label="'link'"
              :type="'text'"
              :placeholder="'Link'"
              :error-messages="validationErrors['link']"
              isBordered
            />
          </div>

          <p class="form-create__label">Link Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'link_name'"
              :label="'link_name'"
              :type="'text'"
              :placeholder="'Link Name'"
              :error-messages="validationErrors['linkName']"
              isBordered
            />
          </div>

          <p class="form-create__label">Date from</p>
          <div class="input-container">
            <date-picker
              v-model="formDataToSend.from"
              type="date"
              :value-type="'DD.MM.YYYY'"
              :show-second="false"
              :format="'DD.MM.YYYY'"
              :title-format="'DD.MM.YYYY'"
              placeholder="dd.mm.yyy"
              :error-messages="validationErrors['from']"
            ></date-picker>
          </div>

          <p class="form-create__label">Date to</p>
          <div class="input-container">
            <date-picker
              v-model="formDataToSend.to"
              type="date"
              :value-type="'DD.MM.YYYY'"
              :show-second="false"
              :format="'DD.MM.YYYY'"
              :title-format="'DD.MM.YYYY'"
              placeholder="dd.mm.yyy"
              :error-messages="validationErrors['to']"
            ></date-picker>
          </div>

          <p class="form-create__label">Image Banners</p>
          <div class="input-container">
            <div class="form-create__images">
              <div
                v-for="(image, index) in formDataToSend.img"
                :key="image.id"
                class="form-create__image"
              >
                <picture-input
                  v-if="
                    formDataToSend.img[index].file == null &&
                    formDataToSend.imgUrl[index].urlImg == null
                  "
                  :ref="`pictureInput_${index}`"
                  @change="handleChoosePhoto(index)"
                  accept="image/jpeg,image/png"
                  size="100"
                  width="220"
                  height="220"
                  :name="`image_${index}`"
                  buttonClass="change-image__button"
                  :customStrings="{ drag: '+', change: 'Change' }"
                />
                <img
                  v-if="formDataToSend.img[index].file != null"
                  :id="`blah_${index}`"
                  src="#"
                  class="form-create__image-load"
                  alt="load"
                />
                <img
                  class="form-create__image-load"
                  v-if="formDataToSend.imgUrl[index].urlImg != null"
                  :src="formDataToSend.imgUrl[index].urlImg"
                  alt="Not load img"
                />
                <div
                  @click="handleChangeImage(index)"
                  v-if="
                    formDataToSend.img[index].file != null ||
                    formDataToSend.imgUrl[index].urlImg != null
                  "
                  class="form-create__change-image"
                >
                  <RestoreIcon />
                </div>
                <div
                  v-if="index != 0"
                  @click="handleDeleteImage(index)"
                  class="form-create__delete-image"
                >
                  <CancelIcon />
                </div>
              </div>
              <!-- <div @click="handleAddImage" class="form-create__add-image">
                <CancelIcon />
              </div> -->
            </div>

            <Notification :error-messages="validationErrors['images']" />
          </div>

          <p class="form-create__label">Description</p>
          <div class="input-container">
            <InputTextarea
              :set-value="formDataToSend"
              :id="'description'"
              :label="'description'"
              :placeholder="'Description'"
              :error-messages="validationErrors['description']"
              isBordered
            />
          </div>
          <div v-if="validationErrors" class="form-create__error">
            <div v-for="(item, index) in Object.values(validationErrors)" :key="index">
              <div v-if="Object.keys(validationErrors)[index].includes('templates')">
                {{ item[0] }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <MainCheckbox :label="'Active'" :id="'status'" :set-value="formDataToSend" />
          </div>
          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import { seoTransform } from "~/helpers/seoTransform";
import ROUTE from "~/constants/routes";
import PictureInput from "vue-picture-input";
import templatesApi from "~/api/templates";
import DatePicker from "vue2-datepicker";
import moment from "moment";

import "vue2-datepicker/index.css";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import InputTextarea from "~/components/atoms/inputs/InputTextarea.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";
import Notification from "~/components/molecules/Notification.vue";

import CancelIcon from "~/assets/images/icons/cancel-icon.svg";
import RestoreIcon from "~/assets/images/icons/restotre.svg";

export default {
  name: "HolidaysEdit",
  metaInfo: {
    title: "Holidays Page Edit",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        page: "",
        from: null,
        to: null,
        description: "",
        link: "",
        link_name: "",
        status: true,
        img: [],
        imgUrl: [],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    InputTextarea,
    MainCheckbox,
    CancelIcon,
    RestoreIcon,
    Notification,
    PictureInput,
    DatePicker,
  },
  mounted() {
    this.getItem();
  },
  computed: {
    ...mapState("templates", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.BANNERS_LIST.replace(":page", 1);
    },
    getId() {
      return this.$route.params.id;
    },
  },
  methods: {
    handleSubmit() {
      const url = `/${this.getId}`;

      const data = {
        name: this.formDataToSend.name,
        page: this.formDataToSend.page,
        from: this.formDataToSend.from,
        to: this.formDataToSend.to,
        link: this.formDataToSend.link,
        link_name: this.formDataToSend.link_name,
        description: this.formDataToSend.description,
        status: this.formDataToSend.status,
      };

      if (this.formDataToSend.imgUrl.length > 0) {
        const arrayImages = this.formDataToSend.imgUrl;
        for (let i = 0; arrayImages.length > i; i++) {
          if (arrayImages[i].url != null) {
            data.image = arrayImages[i].url;
          }
        }
      }

      this.$store.dispatch("templates/editBanners", { url: url, editData: data });
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.BANNERS_LIST.replace(":page", 1),
      });
    },
    setName(value) {
      this.formDataToSend.name = value.trim();
      this.setSeoName(value);
    },
    setSeoName(data) {
      const value = seoTransform(data);
      this.formDataToSend.seo_name = value;
    },

    getItem() {
      const url = `/${this.getId}`;
      try {
        templatesApi.getBannersItems(url).then((res) => {
          this.$store.commit("templates/setError", {});
          this.$store.commit("templates/setValidationErrors", {});
          const data = res.data;

          this.formDataToSend.name = data.name;
          this.formDataToSend.page = data.page;
          this.formDataToSend.from = moment(data.from).format("DD.MM.YYYY");
          this.formDataToSend.to = moment(data.to).format("DD.MM.YYYY");
          this.formDataToSend.link = data.link;
          this.formDataToSend.link_name = data.linkName;
          this.formDataToSend.description = data.description;
          this.formDataToSend.status = data.status;

          if (data.image.length > 0) {
            this.formDataToSend.img.push({
              file: null,
              id: Math.floor(Math.random() * 10000),
            });
            this.formDataToSend.imgUrl.push({
              url: data.image,
              urlImg: data.imageUrl,
            });
          } else {
            this.formDataToSend.img.push({
              file: null,
              id: Math.floor(Math.random() * 10000),
            });
            this.formDataToSend.imgUrl.push({
              url: null,
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    handleChoosePhoto(index) {
      setTimeout(() => {
        this.formDataToSend.img[index].file = document.querySelector(
          `input[name="image_${index}"]`,
        ).files[0];
        const reader = new FileReader();

        reader.onload = function (e) {
          document.getElementById(`blah_${index}`).setAttribute("src", e.target.result);
        };

        reader.readAsDataURL(this.formDataToSend.img[index].file);

        this.$store.commit("categories/setLoading", true);
        const data = new FormData();
        data.append("image", this.formDataToSend.img[index].file);
        templatesApi
          .bannersImagesUpload(data)
          .then((res) => {
            this.formDataToSend.imgUrl[index].url = res.data.fileName;
          })
          .catch((error) => {
            this.formDataToSend.img[index].file = null;
            this.errorModal = true;
            this.errorModalText = "You can't upload images. Error";
          })
          .finally(() => {
            this.$store.commit("categories/setLoading", false);
          });
      }, 0);
    },
    handleAddImage() {
      if (
        this.formDataToSend.img.length == 1 ||
        this.formDataToSend.img[this.formDataToSend.img.length - 1].file != null
      ) {
        this.formDataToSend.img.push({
          file: null,
          id: Math.floor(Math.random() * 100),
        });
        this.formDataToSend.imgUrl.push({
          url: null,
        });
      }
    },
    handleDeleteImage(index) {
      if (this.formDataToSend.imgUrl[index].url != null) {
        this.formDataToSend.img.splice(index, 1);
        this.formDataToSend.imgUrl.splice(index, 1);
      } else {
        this.formDataToSend.img.splice(index, 1);
        this.formDataToSend.imgUrl.splice(index, 1);
      }
    },

    handleChangeImage(index) {
      this.formDataToSend.img[index].file = null;
      this.formDataToSend.imgUrl[index].url = null;
      this.formDataToSend.imgUrl[index].urlImg = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-create {
  &__images {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  &__image {
    position: relative;
    width: 100%;
    height: 220px;
    margin: 0 30px 45px 0;
    border: 1px solid $mainDisabled;
  }

  &__delete-image {
    position: absolute;
    top: -19px;
    right: -26px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }

  &__add-image {
    position: absolute;
    top: -19px;
    right: -8px;
    cursor: pointer;
    transform: rotate(45deg);

    svg {
      path {
        fill: $mainSecondColor;
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &__image-load {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }

  &__change-image {
    position: absolute;
    bottom: -40px;
    left: 44%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: $mainColor;
    border-radius: 50px;
    cursor: pointer;

    svg {
      path {
        fill: $g-color-white;
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }
}
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
</style>
